<template>
  <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-1 mb-lg-4">
    <b-card
      :id="`${shortHand}_card`"
      class="shadow-none border category-titles"
    >
      <!-- <b-button @click="$emit('event', title)" class="cross-btn"><i class="far fa-times-circle"></i></b-button> -->
      <div class="d-block" v-on:click="onTitleClick()">
        <b-card-title>{{ title }}</b-card-title>
        <div class="clr-box-btns d-flex align-items-center">
          <span
            v-if="!!fixAmount"
            class="clr-bx-btn text-center py-1 px-1 fixed-amount"
            v-b-tooltip.hover="{ variant: 'primary' }"
            title="Your Amount"
            :style="{ width: `${percantageCal(value2)}%` }"
          >
            {{ value2 | currency("$", 0) }}
          </span>
          <span
            v-else
            class="clr-bx-btn text-center py-1 px-1 your-amount"
            :class="{ 'negative-bg': getColor(value2) }"
            v-b-tooltip.hover="{ variant: 'primary' }"
            title="Predicted Amount"
            :style="{ width: `${percantageCal(value2)}%` }"
          >
            <template v-if="value2>=0">
              {{ value2 | currency("$", 0) }}
            </template>
            <template v-else>
              $0
            </template>
          </span>
          <span
            v-if="showPeer"
            class="clr-bx-btn text-center py-1 px-1 peers-amount"
            :class="{ 'negative-bg': getColor(value1) }"
            v-b-tooltip.hover="{ variant: 'primary' }"
            title="Your Peers"
            :style="{ width: `${percantageCal(value1)}%` }"
          >
            {{ value1 | currency("$", 0) }}
          </span>
        </div>
        <!-- <div class="edit-budget-amount">                                                                                                                                                                                                                                                       
                    <b-button v-on:click="isHidden = !isHidden" variant="light" block  size="sm">
                        <i class="fas fa-edit"></i> Your Budget Amount
                        <span class="d-inline-block float-right"><i class="fas fa-plus"></i></span>
                    </b-button> 
                </div> -->
        <div class="edit-budget-amount border rounded bg-light p-1">
          <div class="d-flex justify-content-around">
            <a
              role="button"
              class="mx-2 small font-weight-bold your-amount-text"
            >
              <i class="fas fa-edit" aria-hidden="true"></i>
              Your Amount
            </a>
            <span class="mx-2 small font-weight-bold your-peers-text">
              Your Peers
              <!-- <i class="fas fa-plus" aria-hidden="true"></i> -->
            </span>
          </div>
        </div>
      </div>
      <div
        :id="`${shortHand}_card_click`"
        class="add-fudget-form mt-2 border rounded p-2 bg-light"
        ref="ddd-n"
        :class="{ 'd-none': isHidden || defaultActive != title }"
      >
        <div class="position-relative d-block">
          <!-- <button
            type="button"
            class="btn cross-btn btn-secondary"
            v-on:click="isHidden = !isHidden"
          >
            <i class="far fa-times" aria-hidden="true"></i>
          </button> -->
          <b-form class="m-1" @submit="onSubmit">
            <b-form-group>
              <label class="row" for="input1">
                <div class="col-12 col-md-12">
                  
                  <div
                    class="mt-2 mb-2 d-flex w-100 align-items-center justify-content-between"
                  >
                    <template v-if="checkIcon">
                      <!-- <a :href="checkIcon" class="btn btn-danger font-weight-bold ml-2 ml-md-auto ml-lg-auto absolute-in-mobile" style="font-size: 10px; margin: auto; color: #fff;" target="_parent">Ideas</a> -->
                      <a
                        @click="changeUsesvalue(title)"
                        class="btn btn-sm btn-purple"
                        style="color: #fff"
                        >Ideas</a
                      >
                    </template>
                    <b-button
                      class="btn btn-sm"
                      @click="
                        fixAmount = null;
                        fixAmt();
                      "
                      >Clear</b-button
                    >
                  </div>
                  <span>Fixed Amount</span>
                </div>
              </label>
              <NumberInput
                :model="fixAmount"
                @changeValue="numberValueChange"
                name="fixAmount"
              />
              <!-- <b-form-input 
                            v-on:keyup="fixAmt"
                            v-model.lazy="fixAmount"
                            v-money="
                                fixAmount !== null
                                ? money
                                : null
                            "
                            placeholder="Enter a value"
                            size="sm"
                            >
                        </b-form-input> -->
            </b-form-group>
            <b-form-group>
              <label class="w-100">
                <div
                  class="mt-2 d-flex w-100 align-items-center justify-content-between"
                >
                  <span> Frequency </span>
                  <!-- <b-button class="clear-sm" @click="frequency = 12"
                    >Clear</b-button
                  > -->
                </div>
              </label>
              <b-form-select
                v-model="frequency"
                :options="[
                  { text: 'Monthly', value: 12 },
                  { text: 'Weekly', value: 52 },
                  { text: 'Quarterly', value: 4 },
                  { text: 'Semi-Annually', value: 2 },
                  { text: 'Annually', value: 1 },
                ]"
                :value="null"
                size="sm"
              >
              </b-form-select>
            </b-form-group>
          </b-form>
          <b-form-group class="text-center">
            <b-button type="button" size="sm" v-on:click="isHidden = !isHidden"
              >Close</b-button
            >
          </b-form-group>
        </div>
      </div>
    </b-card>
    <b-modal
      id="chatGptList"
      v-model="modalShow"
      scrollable
      size="xl"
      content-class="get-advice-modal"
      v-if="modalShow == true"
      hide-footer
    >
      <ChatGptList :uses="uses" />
    </b-modal>
  </b-col>
</template>
<script>
import NumberInput from "@/components/NumberInput";
import ChatGptList from "@/components/ChatGptList";
import transformer_38 from "@/transformers/transformer_new";
import transformer_links from "@/transformers/transformer_links";
export default {
  name: "budget-component",
  props: {
    title: String,
    value1: Number,
    value2: Number,
    frequencyOptions: Array,
    changedValues: Object,
    newValueMorgage: Object,
    newValueVahicle: Object,
    newValueDebt: Object,
    newValueSaving: Object,
    newValueHealth: Object,
    showPeer: Boolean,
    grid: Boolean,
    zip: String,
    age: Number,
    defaultActiveTab: String,
  },
  components: {
    NumberInput,
    ChatGptList,
  },
  data() {
    return {
      modalShow: false,
      uses: "",
      isHidden: true,
      fixAmount: null,
      frequency: 12,
      defaultActive: "",
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  watch: {
    defaultActiveTab: {
      handler(data) {
        this.defaultActive = data;
      },
      deep: true,
    },
    newValueMorgage: function (newVal) {
      if (this.title === "Rent or Mortgage Payment") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueVahicle: function (newVal) {
      if (this.title === "Car Payments") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueDebt: function (newVal) {
      if (this.title === "Other Debt Payments & Obligations") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueSaving: function (newVal) {
      if (this.title == "Amount to Savings Each Period") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    newValueHealth: function (newVal) {
      if (this.title == "Health Insurance") {
        if (newVal.val && !!newVal.val && typeof newVal.val === "string") {
          this.fixAmount = newVal.val;
        } else {
          this.fixAmount = null;
        }
        this.frequency = newVal.freq;
      }
    },
    grid: {
      handler(val) {
        this.grid = val;
      },
      deep: true,
      immediate: true,
    },
    fixAmount() {
      // this.$emit('changeValue', this.title,this.fixAmount? parseInt(this.unmaskMoneyValue(this.fixAmount))*this.frequency: null,this.fixAmount? this.unmaskMoneyValue(this.fixAmount) :null,this.frequency)
    },
    frequency() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
  },
  created() {},
  mounted() {
    //   console.log(this.title)
  },
  methods: {
    onTitleClick() {
      this.isHidden = false;
      this.$emit("defaultActiveTabAction", this.title);
    },
    changeUsesvalue(title) {
      // alert(title)
      const data = {
        title,
        predicted: this.value2,
        peer: this.value1,
        type: "Major",
        zip: this.zip,
        age: this.age,
      };
      this.uses = data;
      this.modalShow = true;
    },
    hideMenus() {
      this.isHidden = true;
      this.$refs["ddd-n"].classList.add("d-none");
    },
    onSubmit(event) {
      event.preventDefault();
    },
    getColor(arg) {
      if (arg < 0) {
        return true;
      } else {
        return false;
      }
    },
    fixAmt() {
      this.$emit(
        "changeValue",
        this.title,
        this.fixAmount
          ? parseInt(this.unmaskMoneyValue(this.fixAmount)) * this.frequency
          : null,
        this.fixAmount ? this.unmaskMoneyValue(this.fixAmount) : null,
        this.frequency
      );
    },
    numberValueChange(arg, arg2) {
      var self = this;
      self[arg2] = arg;
      this.fixAmt();
    },
    percantageCal(arg) {
      //   if(!!this.fixAmount){
      //     const fixAmount = parseInt(this.unmaskMoneyValue(this.fixAmount))
      //     const total = this.value1+fixAmount

      //     if(typeof arg === 'string')
      //         return (fixAmount/total)*100
      //     else
      //         return (arg/total)*100
      //   } else {
      const total = this.value1 + this.value2;
      if (total === 0 && this.grid === true) return 50;
      else if (total === 0 && this.grid === false) return 4;
      else return (arg / total) * 100;
      //   }
    },
    unmaskMoneyValue(val) {
      if (val && typeof val === "string")
        return val.replace("$", "").replace(",", "");
      else return val;
    },
  },
  computed: {
    checkIcon() {
      const short_hand = Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
      return transformer_links[short_hand];
    },
    shortHand() {
      return Object.keys(transformer_38).find(
        (item) => transformer_38[item] === this.title
      );
    },
  },
};
</script>
